import { defineComponent, ref, computed, inject, watch } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PortfolioTransactionDelete",
  props: {
    locale: { type: null, required: true },
    id: { type: null, required: true },
    transactionId: { type: null, required: true },
    securityId: { type: null, required: true }
  },
  emits: ["store-error", "data-load", "submit", "cancel"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const action = ref("FETCH");
    const componentInputs = computed(() => ({
      id: props.id,
      action: action.value,
      transactionId: props.transactionId,
      securityId: props.securityId,
      language: props.locale
    }));
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate } = localizationSupport;
    const storeModule = useStoreModule(
      {
        storeModule: inject("storeModule")
      },
      componentInputs,
      emits,
      {
        requestDataOnComponentInputsChange: false
      }
    );
    const { storeRequestData, isLoadingStoreData, storeCleanUp } = storeModule;
    const onDelete = async () => {
      if (!isLoadingStoreData.value) {
        action.value = "DELETE";
        await storeCleanUp(componentInputs.value);
        await storeRequestData();
        action.value = "FETCH";
        emits("submit");
      }
    };
    const onCancel = () => {
      emits("cancel");
    };
    watch(
      () => props,
      () => {
        action.value = "FETCH";
        void storeCleanUp(componentInputs.value).then(storeRequestData);
      },
      { immediate: true }
    );
    return { __sfc: true, action, props, emits, componentInputs, localizationSupport, translate, storeModule, storeRequestData, isLoadingStoreData, storeCleanUp, onDelete, onCancel };
  }
});

export { _sfc_main as default };
